import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

export default function Header(props) {
  const [title, setTitle] = useState("");

  useEffect(() => {
    setTitle(props.title);
  }, [props.title]);

  return (
    <Helmet>
      <link
        rel="icon"
        type="image/png"
        href={process.env.PUBLIC_URL + "/emoji.png"}
      />
      <title>mesanfaz - {title}</title>
    </Helmet>
  );
}
